const siteConfig = {
  brandName: "gorequartz",
  logo: "/brand/logo.svg",
  metaTitle: "gorequartz | Singapore gourmet food, gifts & artisan ingredients",
  tagline: "Exceptional food, thoughtfully sourced.",
  description:
    "A Singapore gourmet market for artisan cheese, charcuterie, seafood, pantry essentials, fresh bakery goods, and memorable gifts.",
  contact: {
    email: "range@gorequartz.fun",
    address: "7A Meng Suan Rd, Singapore 779311",
    supportHours: "Monday–Friday, 9:00 AM–6:00 PM SGT",
    hours: "Monday–Friday, 9:00 AM–6:00 PM SGT",
  },
  country: "Singapore",
  countryCode: "SG",
  currency: "USD",
  locale: "en-SG",
  timeZone: "Asia/Singapore",
  taxRate: 0.09,
  standardShippingRate: 9.99,
  storageKeys: {
    cart: "gorequartz.cart",
    wishlist: "gorequartz.wishlist",
    promo: "gorequartz.promo",
  },
};

export { siteConfig };
export default siteConfig;
